import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { FarbweltTeaser } from "@/components";
import { useFarbwelt } from "@/hooks/useFarbwelt";
import { AdContainer } from "@/ads/components/AdContainer";
import { AdSlotIds } from "@/shared/types";
import { useShowAds } from "@/ads/hooks/useShowAds";
export const AdFooter = () => {
    const { isFarbweltActive, teasers } = useFarbwelt();
    const { showSection } = useShowAds();
    const teaser = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleTop"));
    return (_jsx(Box, { display: isFarbweltActive || showSection([AdSlotIds.AD_MEDIUM_RECTANGLE_MOBILE])
            ? {
                "breakpoint.base": "flex",
                "breakpoint.lg": "none",
            }
            : "none", justifyContent: "center", height: isFarbweltActive ? "250px" : "300px", alignItems: "center", children: isFarbweltActive ? (_jsx(FarbweltTeaser, { teaser: teaser, av_zone: "bottom" })) : (_jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_MOBILE, showLabel: true, display: "flex" })) }));
};
